import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import {FORMAT_TIME} from "types/enums";
const {INPUT, CURRENCY, DATE, NUMBER, LIST, COMBO_BOX, AUTO_COMPLETE} =
  FIELD_TYPE;
import {FIELD_TYPE} from "types/enums";
import {listGender, listTTPhieuKho} from "data/list";
import {DataFormField} from "types/models/input-field-type";
import {ColumnProps} from "types/models";

const fields: any[] = [
  {
    type: INPUT,
    label: "Mã phiếu",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Số hóa đơn",
    name: "soHoaDon",
    rules: [
      {required: true, message: "Chưa nhập số hóa đơn"},
      {max: 12, message: "Tối đa nhập 12 kí tự"},
    ],
  },
  {
    type: DATE,
    label: "Ngày hóa đơn",
    name: "ngayHoaDon",
    rules: [{required: true, message: "Chưa nhập Ngày hóa đơn"}],
  },
  {
    type: INPUT,
    label: "Tiêu đề phiếu",
    name: "tieuDe",
  },
  {
    type: COMBO_BOX,
    label: "Kho nhập",
    name: "khoNhapId",
    rules: [{required: true, message: "Chưa chọn kho nhập"}],
  },
  {
    type: COMBO_BOX,
    label: "Kho xuất",
    name: "khoXuatId",
    rules: [{required: true, message: "Chưa chọn kho xuất"}],
  },
  {
    type: AUTO_COMPLETE,
    label: "Nhà cung cấp",
    name: "nhaCungCap",
    rules: [{required: true, message: "Chưa chọn nhà cung cấp"}],
  },
  {
    type: INPUT,
    label: "Người lập",
    name: "nguoiLap",
    placeholder: "Chọn",
    value: localStorage.getItem("fullName"),
    rules: [{required: true, message: "Chưa nhập người lập phiếu"}],
    // options: [
    //   { value: 1, label: "Đã thanh toán" },
    //   { value: 0, label: "Chưa thanh toán" },
    // ],
  },
  {
    type: DATE,
    label: "Ngày dự trù",
    name: "ngayDuTru",
  },
  {
    type: INPUT,
    label: "Người giao",
    name: "nguoiGiao",
  },
  {
    type: INPUT,
    label: "Người nhận",
    name: "nguoiNhan",
    placeholder: "Chọn",
  },
  {
    type: DATE,
    label: "Ngày hoàn thành",
    name: "ngayHoanThanh",
    placeholder: "Chọn",
  },
  {
    type: CURRENCY,
    label: "Tổng giá trị",
    name: "tongGiaTri",
    disable: true,
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
  },
  {
    type: COMBO_BOX,
    label: "Tình trạng phiếu",
    name: "tinhTrang",
    options: listTTPhieuKho,
    disable: true,
  },
];

const columnsTable: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    render: (value, record, index) => index + 1,
    show: true,
    align: "center",
    width: 40,
  },
  {
    type: INPUT,
    dataIndex: "id",
    key: "id",
    title: "",
    align: "center",
    width: 0,
    hidden: true,
  },
  {
    type: AUTO_COMPLETE,
    key: "glassesId",
    dataIndex: "glassesId",
    show: true,
    width: 0,
    hidden: true,
  },
  {
    type: AUTO_COMPLETE,
    title: "Mã vật tư",
    key: "code",
    dataIndex: "code",
    align: "center",
    show: true,
    width: 120,
  },
  {
    type: AUTO_COMPLETE,
    title: "Số lô",
    key: "soLo",
    dataIndex: "soLo",
    show: true,
    align: "left",
    width: 160,
  },
  {
    type: AUTO_COMPLETE,
    title: "Tên vật tư",
    key: "glassesName",
    dataIndex: "glassesName",
    show: true,
    align: "left",
    autoFocus: true,
    width: 450,
  },
  {
    type: INPUT,
    title: "Đơn vị tính",
    key: "donViTInh",
    dataIndex: "donViTInh",
    show: true,
    align: "left",
    disabled: true,
    width: 90,
  },
  {
    type: NUMBER,
    title: "SL tồn",
    key: "tonKho",
    dataIndex: "tonKho",
    show: true,
    align: "center",
    disabled: true,
    width: 90,
  },
  {
    type: NUMBER,
    title: "SL",
    key: "soLuongNhap",
    dataIndex: "soLuongNhap",
    show: true,
    align: "center",
    width: 80,
  },
  {
    type: CURRENCY,
    title: "Đơn giá nhập",
    key: "donGiaNhap",
    dataIndex: "donGiaNhap",
    show: true,
    align: "right",
    width: 200,
  },
  {
    type: CURRENCY,
    title: "Thành tiền",
    key: "thanhTien",
    dataIndex: "thanhTien",
    show: true,
    align: "right",
    disabled: true,
    width: 200,
  },
  {
    type: CURRENCY,
    title: "Đơn giá bán",
    key: "donGiaBan",
    dataIndex: "donGiaBan",
    show: true,
    align: "right",
    width: 200,
  },
  {
    type: NUMBER,
    title: "VAT",
    key: "vat",
    dataIndex: "vat",
    show: true,
    align: "right",
    max: 80,
  },
  {
    type: INPUT,
    title: "Loại vật tư",
    key: "loaiVatTu",
    dataIndex: "loaiVatTu",
    show: true,
    align: "left",
    disabled: true,
    width: 260,
  },
  {
    type: INPUT,
    title: "Vật liệu",
    key: "vatLieu",
    dataIndex: "vatLieu",
    show: true,
    align: "left",
    disabled: true,
    width: 180,
  },
  {
    type: INPUT,
    title: "Màu sắc",
    key: "mauSac",
    dataIndex: "mauSac",
    show: true,
    align: "left",
    width: 120,
  },
  {
    type: COMBO_BOX,
    title: "Giới tính",
    key: "gioiTinh",
    dataIndex: "gioiTinh",
    options: listGender,
    show: true,
    align: "left",
    disabled: true,
    width: 90,
  },
  {
    type: INPUT,
    title: "Kích cỡ",
    key: "kichCo",
    dataIndex: "kichCo",
    show: true,
    align: "left",
    width: 90,
  },

  {
    type: AUTO_COMPLETE,
    title: "Nhà cung cấp",
    key: "nhaCungCap",
    dataIndex: "nhaCungCap",
    show: true,
    align: "left",
    width: 200,
  },
  {
    type: AUTO_COMPLETE,
    title: "Xuất xứ",
    key: "nuocSanXuat",
    dataIndex: "nuocSanXuat",
    show: true,
    align: "left",
    width: 110,
  },
  {
    type: INPUT,
    title: "Đặc điểm khác",
    key: "dacDiemKhac",
    dataIndex: "dacDiemKhac",
    show: true,
    align: "left",
    width: 120,
  },
  {
    type: INPUT,
    title: "Ghi chú",
    key: "note",
    dataIndex: "note",
    show: true,
    align: "left",
    width: 90,
  },
  {
    title: "",
    dataIndex: "action",
    key: "action",
    align: "center",
    width: 40,
    fixed: "right" as any,
    show: true,
  },
];

export {columnsTable, fields};
